import { ButtonHTMLAttributes, forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MyButtonRef } from '../models/ButtonProps';

export interface MyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  proceed: () => void;
}

const ButtonEditMenu = forwardRef<MyButtonRef, MyButtonProps>((props, ref) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Define custom event handlers
  useImperativeHandle(ref, () => ({
    focus: () => {
      buttonRef.current?.focus();
    },
    disable: () => {
      buttonRef.current?.setAttribute('disabled', 'true');
    },
    enable: () => {
      buttonRef.current?.removeAttribute('disabled');
    },
    blur: () => {
      buttonRef.current?.blur();
    },
  }));

  return (
    <>
      <button type="button" ref={buttonRef} onClick={props.proceed} className="btn btn-primary">
        {t('MenuList.Button.detail')}
      </button>
    </>
  );
});

export default ButtonEditMenu;
